export default "__VITE_ASSET__d2528a23__"